module.exports = __webpack_public_path__ + "media/images/featured_cover_picture-f0c346ded7abe9952a79033d4a67df35.png";